var map = {
	"./bash": 1682,
	"./java": 1683,
	"./json": 1684,
	"./julia": 1685,
	"./python": 1686,
	"./r": 1687,
	"./rust": 1688,
	"./scala": 1689,
	"./shell": 1690,
	"./sql": 1691,
	"./xml": 1692,
	"./yaml": 1693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1681;